var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout-item text-center"},[_c('h5',{staticClass:"md-layout-item"},[_vm._v("Provisioning Tenant...")]),_c('md-progress-spinner',{attrs:{"md-diameter":45,"md-stroke":6,"md-mode":"indeterminate"}}),_c('br'),_c('h6',{staticClass:"md-layout-item"},[_vm._v(" "+_vm._s(_vm.status.customStatus || "Starting...")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }